/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, HtmlParser } from 'sarsaparilla';

export default class TertiaryContent extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        id: PropTypes.string,
        additionalInformation: PropTypes.string,
    };
    renderBreadcrumb() {
        const path = [
            { url: '/', title: 'Home' },
            { url: `/permits/${this.props.id}`, title: this.props.name },
            { title: 'Additional Information' },
        ];

        return <Breadcrumbs path={path} />;
    }

    renderTertiaryDesc() {
        return (
            <div className="tertiary-content">
                <h1>{this.props.name}</h1>
                <div id="division-permit-desc" className="permit-division-description">
                    <HtmlParser html={this.props.additionalInformation} />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="permit-content-outer-wrap">
                <section className="permit-content-main division-details-container">
                    {this.renderBreadcrumb()}
                    {this.renderTertiaryDesc()}
                </section>
            </div>
        );
    }
}
